import React from "react";
import styled from "styled-components";

import { Resource } from "@examspark/types";

import AssetTypeIcon from "./AssetTypeIcon";

const Styled = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  min-width: 0;
`;
const StyledName = styled.div`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const StyledNumber = styled.div`
  font-size: 0.85em;
  color: #888;
  font-family: input-mono, monospace;
`;

/**
 * This component presents an asses icon, based on type, the asset name, and
 * the asset's idInc value
 */
const AssetTitle = (props: { item?: Resource; hideIcon?: boolean }) => {
  return (
    <Styled>
      {!props.hideIcon && <AssetTypeIcon item={props.item} />}
      <StyledName>{props.item?.name ?? "Untitled"}</StyledName>
      {!!props.item?.idInc && <StyledNumber>#{props.item?.idInc}</StyledNumber>}
    </Styled>
  );
};

export default AssetTitle;
